import React from 'react';
import CookieConsent from 'react-cookie-consent';
import styled from 'styled-components';
import {
  spacer,
  mediaBreakpointUp,
  gray,
  color,
  gridGutterWidth,
  zIndex,
  themeColor,
  darkenColor,
  resetLinkStyle,
} from '@whitelabel/helpers/style';

export const StyledConsentBanner = styled(({ className, ...props }) => (
  <CookieConsent containerClasses={`${className} container`} {...props} />
))`
  position: static !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: ${color('white')};

  ${mediaBreakpointUp('sm')`
    flex-direction: row;
  `}

  div {
    padding-top: ${spacer};
    padding-bottom: ${spacer};

    ${mediaBreakpointUp('sm')`
      padding-inline-end: ${gridGutterWidth('sm')};
    `}

    ${mediaBreakpointUp('md')`
      padding-inline-end: ${gridGutterWidth('md')};
    `}

    ${mediaBreakpointUp('lg')`
      padding-inline-end: ${gridGutterWidth('lg')};
    `}
  }

  button {
    margin-bottom: ${spacer};

    ${mediaBreakpointUp('sm')`
      margin-bottom: 0;
    `}
  }

  a {
    ${resetLinkStyle}
    color: ${themeColor('primary')};
    &:hover {
      color: ${darkenColor(0.1, themeColor('primary'))};
    }
  }
`;

export const StyledConsentBannerBox = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: ${zIndex('contentLayer')};
  width: 100%;
  background-color: ${gray(700)};
`;
